import thankApi from '../apis/thank'
import {} from '../modules/user'
const state = {
  thanksWall: {
    currentPage: 0,
    nextPageUrl: 'http://',
    data: [],
    mediaType: ''
  },
  userInfo: {
    id: 0,
    myThanksTabIndex: 0,
    mediaType: '',
    // 收到的感謝
    myToThanks: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myFromThanks: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  },
  otherUserInfo: {
    myThanksTabIndex: 0,
    mediaType: '',
    myToThanks: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    },
    myFromThanks: {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  }
}
const actions = {
  getThanks ({commit, state}, {page, cb = null} = {}) {
    thankApi.getThanks(
      page,
      state.thanksWall.mediaType,
      (data) => {
        if (data && !data.error) {
          commit('setThanks', {data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getToThanks ({ commit, state }, {userId, page, parentThanksId, perPage, mediaType, cb = null, isSelf}) {
    thankApi.getToThanks(
      userId,
      page,
      parentThanksId,
      perPage,
      mediaType,
      (data) => {
        commit('setToThanks', {isSelf, data})
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getFromThanks ({ commit, state }, {userId, page, parentThanksId, perPage, mediaType, cb = null, isSelf}) {
    thankApi.getFromThanks(
      userId,
      page,
      parentThanksId,
      perPage,
      mediaType,
      (data) => {
        commit('setFromThanks', {isSelf, data})
        if (cb) {
          cb(data)
        }
      }
    )
  }
}

const mutations = {
  // 登出
  // logout (state) {
  //   state.userInfo = {
  //     myThanksTabIndex: 0,
  //     myToThanks: {
  //       currentPage: 0,
  //       nextPageUrl: 'http://',
  //       data: []
  //     },
  //     myFromThanks: {
  //       currentPage: 0,
  //       nextPageUrl: 'http://',
  //       data: []
  //     }
  //   }
  // },
  // 初始化
  resetOtherUserInfo (state) {
    state.otherUserInfo = {
      myThanksTabIndex: 0,
      myToThanks: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      },
      myFromThanks: {
        currentPage: 0,
        nextPageUrl: 'http://',
        data: []
      }
    }
  },
  setThanks (state, {data}) {
    state.thanksWall = {
      ...state.thanksWall,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state.thanksWall.data,
        ...data.data
      ]
    }
  },
  setThanksMediaType (state, mediaType) {
    state.thanksWall = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: [],
      mediaType
    }
  },
  setToThanks (state, {isSelf, data}) {
    const user = isSelf ? 'userInfo' : 'otherUserInfo'
    state[user].myToThanks = {
      ...state[user].myToThanks,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state[user].myToThanks.data,
        ...data.data
      ]
    }
  },
  setUserThanksMediaType (state, {isSelf, mediaType}) {
    const user = isSelf ? 'userInfo' : 'otherUserInfo'
    state[user].mediaType = mediaType
    state[user].myToThanks = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
    state[user].myFromThanks = {
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  },
  setFromThanks (state, {isSelf, data}) {
    const user = isSelf ? 'userInfo' : 'otherUserInfo'
    state[user].myFromThanks = {
      ...state[user].myFromThanks,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state[user].myFromThanks.data,
        ...data.data
      ]
    }
  },
  setMyThanksTabIndex (state, {isSelf, index}) {
    const user = isSelf ? 'userInfo' : 'otherUserInfo'
    state[user].myThanksTabIndex = index
  },
  setThanksTabIndex (state, {index}) {
    state.thanksWall = {
      ...state.thanksWall,
      index
    }
  }
}

export default {
  state,
  mutations,
  actions
}
